import { useEffect, useState } from "react";

const ReturnPolicy = () =>{

    return(<> 
    
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
		<img src="assets/img/banner/return.jpg" alt="MeriPustak-Return-Cancellation-Policy"/>
    </div>

    {/* <!-- About Section Start --> */}
	<section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}>Meripustak.com Return &amp; Cancellation Policy </h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}><b>At MeriPustak, a division of MachwanTech Services Private Limited <a href="https://machwantech.com/" target="_blank">(https://machwantech.com/)</a></b>, we are committed to ensuring you have the best online shopping experience with every purchase. Our return and cancellation policies are designed to be fair, transparent, and customer-friendly. Please read the details below to understand your options.</p><hr/>
							
							 <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"  style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}>Return &amp; Exchange Policy</h3><br/>
							 
							 <ol>
								<li><b>Orders from India</b> 
								
								
									<ul className="ULinside">
										<li><b>Timeframe:</b> You have a 3-day window to request a return or exchange, starting from the day you receive your order.</li>
										<li><b>Conditions for Acceptance:</b> We will only accept returns or exchanges if: 
											<ol>
												<li>The product is <b>damaged</b> (e.g., torn pages, broken binding).</li>
												<li>The product is <b>defective</b> (e.g., printing errors, missing pages).</li>
												<li>The product is <b>not as described</b> or does not match what was shown on the website when you placed the order.</li>
											</ol>
										</li>
										<li><b>Process:</b>
											<ol>
												<li>Contact us within 3 business days of delivery with your <b>Order ID</b> and details of the issue.</li>
												<li>Our Customer Support team will verify your request and provide step-by-step instructions.</li>
												<li>Ensure the product is unused, in its original condition, and includes all price tags, labels, original packaging, and the invoice.</li>
											</ol>
										</li>
									</ul>
								</li><br/>
								<li><b>International Orders (Orders from Other Countries)</b> 
									<ul className="ULinside">
										<li><b>Policy:</b> We do not accept returns or exchanges for international orders unless the wrong product is delivered (i.e., the item you received differs from what you ordered).</li>
										<li><b>	Exception:</b> If the wrong product is delivered, you may request a return or replacement. Contact us with your Order ID and evidence (e.g., photos of the item received).</li>
										<li><b>	Condition:</b> The product must be unused and returned in its original packaging with all accompanying materials (tags, labels, invoice).</li>
									</ul>
								</li><br/>
								<li><b>How to Request a Return or Exchange </b> 
									<ul className="ULinside">
										<li><b>Contact Options: </b>
										<ol>
												<li><b>Email:</b> <a href="mailto:contactus@meripustak.com" target="_blank">contactus@meripustak.com</a></li>
												<li><b>Toll-Free Number:</b> <a href="tel:18008917183" target="_blank">1800 891 7183</a></li>
												<li><b>WhatsApp:</b> <a href="https://wa.me/919990533212" target="_blank">+91 99905 33212</a></li>
										</ol>
										</li>
										<li><b>Working Hours:</b> Monday to Saturday, 10:00 AM to 6:00 PM IST.</li>
										<li><b>Response Time:</b> We will respond to your request within 24 business hours.</li>
										<li><b>Steps:</b> 
										<ol>
												<li>Reach out with your Order ID and a description of the issue (e.g., damaged, defective, or incorrect item).</li>
												<li>Our team will review and confirm eligibility.</li>
												<li>Follow the instructions provided for shipping the item back to us.</li>
										</ol>
										</li>
									</ul>
								</li><br/>
								
								<li><b>When Returns Are Not Possible </b> <br/>
								Returns or exchanges will not be accepted in the following cases: 
									<ul className="ULinside">
										
										<li>The return request is made after 3 business days from delivery (for India orders).</li>
										<li>The product has been used, damaged by the customer, or is not in the same condition as when delivered.</li>
										<li>Serial numbers on the product are tampered with or missing.</li>
										<li>The product is returned without its original packaging, tags, labels, or invoice.</li>
										
									</ul>
								</li><br/>
								
							 </ol>
							
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"  style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}>Cancellation &amp; Refund Process for Prepaid Orders</h3><br/>
							<ol>
								<li><b>How to Cancel an Order</b>
									<ul className="ULinside">
										
										<li><b>Eligibility:</b> You can cancel your order only if it has not yet been dispatched.</li>
										<li><b>Steps: </b>
											<ol>
												<li>Sign in to your MeriPustak account at <a href="https://www.meripustak.com/">www.meripustak.com</a>.</li>
												<li>Go to the <b>'My Orders'</b> section.</li>
												<li>Select the order you wish to cancel and choose the cancellation option.</li>
												<li>Provide any required details (e.g., reason for cancellation).</li>
												<li>Submit your request.</li>
											</ol>
										</li>
										<li><b>Processing: </b>
										<ol>
												<li>We will process your cancellation within 24 business hours.</li>
												<li>You will receive a confirmation via email or SMS once the cancellation is successful.</li>
											</ol>
										</li>
										
									</ul>
								</li>
								<li><b>Refund Process</b>
								
								<ul className="ULinside">
										
										<li><b>Initiation:</b> After cancellation is confirmed, we will initiate a refund for the full order amount.</li>
										<li><b>Payment Mode:</b> The refund will be credited back to the original payment method used during the purchase, such as: 
											<ol>
												<li>Credit card</li>
												<li>Debit card</li>
												<li>Net banking</li>
												<li>UPI</li>
												<li>Paytm</li>
												<li>PhonePe</li>
												<li>Other legal electronic payment modes</li>
											</ol>
										</li>
										<li><b>Timeframe:</b> Expect the refund to reflect in your account within 1 to 7 business days, depending on your bank or payment provider.</li>
										<li><b>Note:</b> This policy applies only to cancellations made before the order is shipped.</li>
										
									</ul>
								</li>
								<li><b>Cancellation Without Prior Notice</b> 
								
								<ul className="ULinside">
										
										<li>We reserve the right to cancel your order without prior notice in certain situations, including:
											<ol>
												<li>Suspected unauthorized or fraudulent use of e-cash or payment methods.</li>
												<li>Evidence of hacker involvement in the order process.</li>
												<li>Receipt of books in poor condition from our suppliers (e.g., damaged stock).</li>
												<li>Unavailability of books from publishers or distributors after your order is placed.</li>
												<li>External factors like natural disasters, communal violence, or riots affecting either the buyer or seller.</li>
											</ol>
										</li>
										<li><b>Notification:</b> If this happens, you will be informed via email or phone about the cancellation and any applicable refund details.</li>
										
									</ul>
								</li>
							</ol>
							<hr></hr>
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".7s"  style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}>Payment Modes &amp; Refund Details After Returns/Cancellations</h3>
							
							<ol>
								<li><b>Automatic Refunds</b>
									<ul className="ULinside">
										<li>Refunds will be credited to the same payment mode or account used for the original transaction.</li>
									</ul>
								</li>
								<li><b>Refund Currency</b>
									<ul className="ULinside">
										<li><b>India Orders:</b> Refunds will be processed in Indian Rupees (INR).</li>
										<li><b>International Orders:</b> Refunds will be processed in USD ($), Euro (€), or GBP (£), depending on the currency used for the original payment.</li>
									</ul>
								</li>
								<li><b>Processing Time</b>
									<ul className="ULinside"><li>Once a return or cancellation request is approved, the refund will be processed within 1 to 7 business days. The exact time may vary based on your bank or payment provider.</li></ul>
								</li>
								<li><b>Refund Discretion </b>
								<ul className="ULinside"><li>Refunds for returned items are subject to MeriPustak’s sole and absolute discretion. We will assess each case to ensure fairness and compliance with our policy.</li></ul>
								</li>
							</ol>
							<hr></hr>
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".7s"  style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}>Our Commitment</h3>
							
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".7s"  style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp"}}>At MeriPustak, your satisfaction is our priority. Whether it’s processing a return, handling a cancellation, or issuing a refund, we aim to make the experience seamless and efficient. If you have any questions or need assistance, our dedicated Customer Support team is here to help. Reach out via email, phone, or WhatsApp, and we’ll address your concerns promptly.</p>
							
                        </div>
                    </div>
                </div>
				</div>
			</div>
        
    </section>

    </>);

}

export default ReturnPolicy;